import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import './App.css';

import TicBoard from './components/ticboard/TicBoard.js';
import ConfigurationBox from './components/ConfigurationBox';
import Players from './components/Players';
import Winner from './components/Winner';
import PeerConnection from './components/PeerConnection';
import ActivePlayer from './components/ActivePlayer';

function App(props) {
  return (
    <div className="App">
      <PeerConnection>
        <ActivePlayer player={props.myIdentity.name} />
        <ConfigurationBox />
        <Players />
        <TicBoard />
        <Winner />
      </PeerConnection>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    partnerIdentity: state.partnerIdentity,
    myIdentity: state.myIdentity
  }
}

export default connect(mapStateToProps)(App);

